import React, { useState } from 'react';
import ProjectDetails from '../components/Programs/ProjectGrading/ProjectDetails';
import Aside from '../modules/SideNav/Aside';

function ProjectDetailsLayout() {
    const rtl = false;

    const [toggled, setToggled] = useState(false);

    const handleToggleSidebar = value => {
        setToggled(value);
    };

    return (
        <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
            <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            />
            <ProjectDetails handleToggleSidebar={handleToggleSidebar} />
        </div>
    );
}

export default ProjectDetailsLayout;
